import * as action from '@/store/action-types'

export default function mapImageIdToImage (albumIdProp, imageIdProp, imageProp) {
  const ret = {}
  ret[imageIdProp] = function (val) {
    const image = this.$store.getters.picture(this[albumIdProp], val) || null
    const data = {}
    data[imageProp] = image
    this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {templateId: this.templateId, data})
  }
  return ret
}



// WEBPACK FOOTER //
// ./src/utils/mapImageIdToImage.js